/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const SupplierId = zod.uuid().describe("Supplier identity.");

export type SupplierId = zod.input<typeof SupplierId>;
export type SupplierIdOutput = zod.output<typeof SupplierId>;
